module.exports = __webpack_public_path__ + "static/img/evidence1.d901b45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence1.png
// module id = bg8B
// module chunks = 1 3